const PLAN_LABELS = { premium: "Premium", premium_plus: "Premium Plus" };
const INTERVAL_LABELS = { monthly: "Mensual", yearly: "Anual" };

export const AdminSubscriptionsTable = ({ rows }) => (
  <div className="overflow-x-auto rounded-xl border border-white/10">
    <table className="w-full text-sm min-w-[900px]" data-testid="admin-subscriptions-table">
      <thead>
        <tr className="border-b border-white/10 text-neutral-500 text-xs uppercase tracking-wide">
          <th className="text-left font-medium px-4 py-3">Nombre</th>
          <th className="text-left font-medium px-4 py-3">Correo</th>
          <th className="text-left font-medium px-4 py-3">Plan</th>
          <th className="text-left font-medium px-4 py-3">Facturación</th>
          <th className="text-left font-medium px-4 py-3">Estado</th>
          <th className="text-left font-medium px-4 py-3">Suscripción Stripe</th>
          <th className="text-left font-medium px-4 py-3">Fecha</th>
        </tr>
      </thead>
      <tbody>
        {rows.map((r) => (
          <tr key={r.stripe_subscription_id || r.email} data-testid={`admin-subscription-row-${r.email}`} className="border-b border-white/5 hover:bg-white/[0.02] transition-colors align-top">
            <td className="px-4 py-3 font-semibold whitespace-nowrap">{r.name}</td>
            <td className="px-4 py-3 text-neutral-400 whitespace-nowrap">{r.email}</td>
            <td className="px-4 py-3 text-neutral-300 whitespace-nowrap">{PLAN_LABELS[r.plan] || r.plan}</td>
            <td className="px-4 py-3 text-neutral-400 whitespace-nowrap">{INTERVAL_LABELS[r.interval] || r.interval}</td>
            <td className="px-4 py-3 whitespace-nowrap">
              <span className="inline-flex items-center gap-1.5 rounded-full bg-brand-blue/10 border border-brand-blue/20 px-2.5 py-1 text-xs font-semibold text-brand-blue">
                <span className="w-1.5 h-1.5 rounded-full bg-brand-blue" /> {r.status || "active"}
              </span>
            </td>
            <td className="px-4 py-3 font-mono text-xs text-neutral-500 whitespace-nowrap">{r.stripe_subscription_id || "—"}</td>
            <td className="px-4 py-3 text-neutral-400 whitespace-nowrap">
              {r.created_at ? new Date(r.created_at).toLocaleString("es-MX") : "—"}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);
